import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationChangeService {
  private languageSubject = new BehaviorSubject<any>(null);
  public language$ = this.languageSubject.asObservable();
  public langSubject = new Subject;

  setLanguage(language: string) {
    this.languageSubject.next(language);
  }
}
